import React, {Component} from 'react';
import {inject, observer} from 'mobx-react';
import BaseConfirmationDialog from '../../components/dialog/BaseConfirmationDialog';
import confirmImage from '../../assets/images/confirmation.jpg';

@inject('dialogStore', 'looperStore')
@observer
class UploadsInProgressDialogContainer extends Component {

    render() {
        const {dialogStore, onDismiss} = this.props;
        return (
            <BaseConfirmationDialog
                onDismiss={onDismiss}
                onSubmit={dialogStore.closeUploadsInProgressConfirm}
                onOutsideClick={dialogStore.closeUploadsInProgressConfirm}
                open={dialogStore.showUploadsInProgressConfirm}
                windowIcon={confirmImage}
                text={{question: 'studio.uploadsInProgress.header', message: 'studio.uploadsInProgress.message'}}
                buttonText='continueUpload'
                cancelButtonText='cancelAndExit'
            />
        );
    }
}

export default UploadsInProgressDialogContainer;
